import { render } from "./sharepointFiles.vue?vue&type=template&id=e2d19926&scoped=true"
import script from "./sharepointFiles.vue?vue&type=script&lang=js"
export * from "./sharepointFiles.vue?vue&type=script&lang=js"

import "./sharepointFiles.vue?vue&type=style&index=0&id=e2d19926&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d19926"]])

export default __exports__